import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

import { communityIsAccessible } from '../_utils/communityAccess';

export interface CommunityAccess {
  isCommunityAccessible: boolean;
}

export const useCommunityAccess = (): CommunityAccess => {
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');

  return { isCommunityAccessible: communityIsAccessible(layoutData?.community) };
};
